<template>
  <div class="md:max-w-[1160px] mx-auto md:px-5 my-10 md:my-12">
    <p v-if="error">{{ error }}</p>
    <div v-else-if="hasPosts > 0">
      <div v-for="(posts, date) in posts" :key="date" class="my-4 flex">
        <h2
          class="font-title text-center leading-7 w-14 md:w-24 flex-shrink-0 border-t-[5px] border-gray-800 pt-2"
        >
          <div class="text-[1.75rem] md:text-[2.875rem]">
            {{ getDay(date) }}
          </div>
          <div class="text-base md:text-[1.625rem]">
            {{ getMonth(date) }}
          </div>
        </h2>
        <div class="w-full grid grid-cols-1" :class="posts.length > 1 ? 'md:grid-cols-2' : ''">
          <blog-post-preview
            v-for="post in posts"
            :key="post.slug"
            :post="post"
            :wide="posts.length === 1"
          ></blog-post-preview>
        </div>
      </div>
    </div>
    <p v-else-if="!loading_posts">No posts.</p>
    <p v-if="loading_posts" class="text-center min-h-screen">Loading...</p>
    <div v-else class="text-center">
      <div
        v-if="no_more_posts"
        class="font-title text-xl text-gray-800 tracking-wider leading-reduced text-center mb-10 px-5"
      >
        No more posts
      </div>
      <button
        v-else
        type="button"
        class="button"
        :disabled="loading_posts"
        @click.prevent="getPosts"
      >
        More Posts
      </button>
    </div>
  </div>
</template>

<script>
import BlogPostPreview from './BlogPostPreview.vue';
import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';

export default {
  name: 'blog-post-list',

  components: {
    BlogPostPreview,
  },

  props: {
    postsUrl: {
      type: String,
      default: '/json/posts',
    },
    category: {
      type: String,
    },
  },

  data() {
    return {
      layout: localStorage.getItem('blog_layout') ? localStorage.getItem('blog_layout') : 'grid',
      posts: {},
      loading_posts: false,
      error: null,
      page: 1,
      first_date: null,
      no_more_posts: false,
    };
  },

  computed: {
    hasPosts() {
      return Object.keys(this.posts).length > 0;
    },
  },

  created() {
    this.getPosts();
  },

  methods: {
    setLayout(layout) {
      this.layout = layout;
      localStorage.setItem('blog_layout', layout);
    },

    getPosts() {
      this.loading_posts = true;
      this.error = null;

      const params = {};

      if (this.first_date) {
        params.before_date = this.first_date;
      }

      if (this.category) {
        params.category = this.category;
      }

      fetch(this.postsUrl + '?' + new URLSearchParams(Object.entries(params)), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then((response) => response.json())
        .then((response) => {
          /**
           * This isn't perfect as you'll still see the load more button when
           * the last page of results has exactly 10 items, but it works for
           * any other case. Would need a more considerable rework to fully fix.
           */
          if (Object.keys(response.data).length < 10) {
            this.no_more_posts = true;
            if (Object.keys(response.data).length === 0) {
              return;
            }
          }

          Object.assign(this.posts, response.data);
          this.first_date = Object.keys(this.posts).sort().shift();
        })
        .catch((error) => {
          this.error = 'Error getting posts.';
        })
        .then(() => {
          this.loading_posts = false;
        });
    },

    resetBlogList() {
      this.posts = {};
      this.page = 1;
      this.first_date = null;
      this.no_more_posts = false;
    },

    getDay(date) {
      return format(parseISO(date), 'd');
    },

    getMonth(date) {
      return format(parseISO(date), 'MMM');
    },
  },

  watch: {
    category(new_category) {
      this.resetBlogList()
      this.getPosts();
    },
  },
};
</script>
